export default "__VITE_ASSET__DaTiiQ98__"